import { getSessionTeamType } from './getTeamType';

export const isProvider = () => getSessionTeamType() === 'Provider';
